import type { FaireProductEntity } from "../../entity_types/product";

export const p_4dbkfhukh2: FaireProductEntity = {
  token: "p_4dbkfhukh2",
  type: "product",
  name: "ABCs from Grandma",
  brandToken: "b_14eeavl3ro",
  brandName: "Sourcebooks",
  imageUrl:
    "https://cdn.faire.com/fastly/b6c4f0a7bc59774ad181c793a6acfe94074e4ab2f641f090920f55f10b5ff577.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cb57fc91efcc68f1e4b2a0a62fd1b9f296fa945b96470c5a4279af76bd887a62.jpeg",
    "https://cdn.faire.com/fastly/c735ee0ea6c3e67ba069b5c1e13560c88f50268993dd13db8cdbc4745bd7fad6.jpeg",
  ],
  priceDollars: 8.9,
  description:
    "Show your little one that Grandma loves you in this charming alphabet board book from Sandra Magsamen, USA Today bestselling author of Welcome Little One!",
  tags: [],
  msrpDollars: 17.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:35.941Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
